import { render, staticRenderFns } from "./AirwallexPayment.vue?vue&type=template&id=5cc17344&scoped=true&"
import script from "./AirwallexPayment.vue?vue&type=script&lang=js&"
export * from "./AirwallexPayment.vue?vue&type=script&lang=js&"
import style0 from "./AirwallexPayment.vue?vue&type=style&index=0&id=5cc17344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc17344",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow})
